import React, { useState, useEffect } from 'react';
import { FluxText, FluxLoadingMessage, FluxList, FluxListItem, FluxListHeader, FluxListSubheader, FluxListDivider, FluxTooltip, FluxButton, FluxListItemTitle, FluxListItemSubtitle } from '@meltwater/flux-web-components-react';
import { getJwtToken } from '../../services/jwt.services';
import jwt_decode from 'jwt-decode';
import apiJiraService from '../../services/jira.apiservice';
import styles from './jira.module.css';
import Paper from '@mui/material/Paper';
import { Chip, Box, Avatar } from '@mui/material';
import logger from '../../utils/logger';

const Jirareporter = ({ issue, updateportalavailable }) => {
    const [username, setUsername] = useState();
    const [loading, setLoading] = useState(false);
    const [badd, setBadd] = useState(false);
    const [jiraissue, setJiraissue] = useState({});
    const [loadingmessage, setLoadingmessage] = useState(false);
    const [requestedparticipants, setRequestedparticipants] = useState(null)
    function fluxwrap(texttowrap) {
        return (
            <FluxText appearance="captionlabel"> {texttowrap}</FluxText>
        )
    }
    useEffect(() => {
        const decoded = jwt_decode(getJwtToken());
        setUsername(decoded.username);
    }, []);
    useEffect(() => {
        setJiraissue(issue);
    }, [issue]);
    useEffect(() => {
        let myrequestpart = jiraissue.requestedparticipants;

        // Special handling for "No Participants" string from the API
        if (myrequestpart === "No Participants") {
            myrequestpart = [];
        }
        else if (myrequestpart !== "") {
            const test = myrequestpart || "";
            myrequestpart = test.split(',');
            myrequestpart = myrequestpart.map((str) => str.trim());
        }
        else {
            myrequestpart = [];
        }

        setRequestedparticipants(myrequestpart);
        setBadd(myrequestpart.includes(username));
        updateportalavailable(myrequestpart.includes(username));

        // eslint-disable-next-line 
    }, [jiraissue, username]);
    // Format the date
    function formatDate(issuedate, blocal) {

        let formattedDateUTC;
        try {
            const originalDate = new Date(issuedate);
            if (blocal) {
                formattedDateUTC = originalDate;
            }
            else {
                formattedDateUTC = originalDate.toUTCString();
            }

            const newdate = formattedDateUTC.toLocaleString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: 'short',
            });

            return newdate;
        } catch (error) {
            return ("Invalid Date")
        }

    }

    const handleAddParticipant = async () => {
        setLoading(true);
        setLoadingmessage(`Adding request participant ${username} please wait...`)
        const response = await apiJiraService.addRequestparticipant(issue.issue);
        if (response.status === 'ok') {
            const newarray = requestedparticipants;
            newarray.push(username);
            logger.debug('Successfully added request participant', { 
                issue: issue.issue, 
                username, 
                participantCount: newarray.length 
            });
            updateportalavailable(true);

            setBadd(true);

            setRequestedparticipants(newarray);
            //issue.requestedparticipants = `${issue.requestedparticipants},${username}`;
            setLoading(false);
        }
        else {
            setLoadingmessage(`Error adding request participant ${username} please try again later...`)
            setTimeout(() => {
                setLoading(false);
            }, 5000);


        }
    };
    const handleRemoveParticipant = async () => {
        setLoading(true);
        setLoadingmessage(`Removing request participant  ${username} please wait...`)
        const response = await apiJiraService.removeRequestparticipant(issue.issue);
        if (response.status === 'ok') {

            const newarray = requestedparticipants;
            const index = newarray.indexOf(username);
            newarray.splice(index, 1);
            logger.debug('Successfully removed request participant', { 
                issue: issue.issue, 
                username, 
                remainingParticipants: newarray 
            });
            setRequestedparticipants(newarray);

            updateportalavailable(false);
            setBadd(false);
            setLoading(false);
            //fetchData(issue.issue);
        }
        else {
            setLoadingmessage(`Error Removing request participant ${username} please try again later...`)
            setTimeout(() => {
                setLoading(false);
            }, 5000);
        }
    };

    // Function to extract Salesforce ID from opportunity URL
    const extractSalesforceId = (opportunityUrl) => {
        if (!opportunityUrl || opportunityUrl === 'NA' || opportunityUrl === 'N/A') {
            return null;
        }
        
        try {
            // Check if the URL contains salesforce or lightning
            if (opportunityUrl.toLowerCase().includes('salesforce') || opportunityUrl.toLowerCase().includes('lightning')) {
                const url = new URL(opportunityUrl);
                
                // Universal Lightning pattern: /lightning/r/{ObjectType}/{id}/
                // This will match any object type (Account, Opportunity, Instance__c, etc.)
                const lightningMatch = url.pathname.match(/\/lightning\/r\/[^/]+\/([a-zA-Z0-9]{15,18})/);
                if (lightningMatch) {
                    return lightningMatch[1];
                }
                
                // Fallback: Look for any 15-18 character ID in the path
                const pathSegments = url.pathname.split('/').filter(segment => segment.length > 0);
                for (const segment of pathSegments) {
                    if (segment.length >= 15 && segment.length <= 18 && /^[a-zA-Z0-9]+$/.test(segment)) {
                        return segment;
                    }
                }
                
                // Final fallback: id parameter
                const idParam = url.searchParams.get('id');
                if (idParam && idParam.length >= 15 && idParam.length <= 18) {
                    return idParam;
                }
            }
        } catch (error) {
            logger.debug('Error extracting Salesforce ID', { 
                opportunityUrl, 
                error: error.message 
            });
        }
        
        return null;
    };

    // Function to generate a consistent color based on username
    const getParticipantColor = (name) => {
        if (!name) return '#6B7280'; // Default gray
        
        // List of colors for participants
        const colors = [
            '#4F46E5', // Indigo
            '#0EA5E9', // Sky blue
            '#10B981', // Emerald
            '#F59E0B', // Amber
            '#EF4444', // Red
            '#8B5CF6'  // Violet
        ];
        
        // Generate a consistent index based on the name
        const index = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
        return colors[index];
    };
    
    // Function to get user initials for avatar
    const getInitials = (name) => {
        if (!name) return '?';
        const parts = name.split(/[@.]/)[0].split(/[._-]/);
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    return (
        <Paper style={{ marginTop: '1px', marginLeft: '1px', marginRight: '1px', marginBottom: '10px', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
                <FluxList >
                    {!issue.issue.toLowerCase().startsWith("kb") && <>
                        <FluxListItem multiline>
                            <FluxListItemTitle>Company</FluxListItemTitle>
                            <FluxListItemSubtitle>{fluxwrap(issue.companyname)}</FluxListItemSubtitle>

                        </FluxListItem>
                        <FluxListItem multiline>
                            Opportunity ID
                            <span slot="detail"> {fluxwrap(issue.opportunityID)}</span>
                        </FluxListItem>
                        
                        {/* Salesforce ID Section */}
                        {extractSalesforceId(issue.opportunity) && (
                            <FluxListItem multiline>
                                Salesforce ID
                                <span slot="detail"> {fluxwrap(extractSalesforceId(issue.opportunity))}</span>
                            </FluxListItem>
                        )}
                        
                        <FluxListItem>
                            {fluxwrap("Support Level")}
                            <span slot="detail"> {fluxwrap(issue.supportlevel)}</span>
                        </FluxListItem>
                        <FluxListDivider></FluxListDivider>

                        <FluxListSubheader >
                            Requested By

                        </FluxListSubheader>

                        <FluxListItem>

                            {fluxwrap(issue.reporteremail)}

                            <FluxTooltip placement='bottom-start' arrow> {fluxwrap(`Requested by ${issue.reporteremail} on   ${formatDate(issue.created, false)}`)}</FluxTooltip>
                            <span slot="detail"> {fluxwrap(formatDate(issue.created, true))}</span>
                        </FluxListItem>


                    </>}
                    <FluxListHeader >
                        Ticket Details
                    </FluxListHeader>
                    <FluxListItem>
                        {fluxwrap("Status")}
                        <span slot="detail"> {fluxwrap(issue.status)}</span>
                    </FluxListItem>
                    <FluxListItem>
                        {fluxwrap(" Priority")}
                        <span slot="detail"> {fluxwrap(issue.priority)}</span>
                    </FluxListItem>
                    {!issue.issue.toLowerCase().startsWith("kb") &&
                        <FluxListItem>
                            {fluxwrap(" RequestType")}
                            <span slot="detail"> {fluxwrap(issue.requesttype)}</span>
                        </FluxListItem>}
                    {!issue.issue.toLowerCase().startsWith("kb") &&
                        <FluxListItem>
                            {fluxwrap("Watchers")}
                            <span slot="detail"> {fluxwrap(issue.watchcount)}</span>
                        </FluxListItem>
                    }
                    <FluxListItem>
                        {fluxwrap("IssueStartDate")}
                        <span slot="detail"> {fluxwrap(issue.issuestartdate)}</span>
                    </FluxListItem>
                    <FluxListItem>
                        {fluxwrap("LinkedMRR")}
                        <span slot="detail"> {fluxwrap(issue.linkedmrr)}</span>
                    </FluxListItem>
                    <FluxListItem>
                        {fluxwrap("Linked Ticket Count")}
                        <span slot="detail"> {fluxwrap(issue.linkedticketcount)}</span>
                    </FluxListItem>
                    <FluxListItem>
                        {fluxwrap("Resolved Date")}
                        <span slot="detail"> {fluxwrap(issue.resolveddate)}</span>
                    </FluxListItem>

                    {/* Request Participants Section - Moved to Bottom */}
                    {!issue.issue.toLowerCase().startsWith("kb") && <>
                        <FluxListDivider></FluxListDivider>
                        <FluxListHeader>
                            Request Participants
                        </FluxListHeader>
                        <FluxListItem>
                            {badd === true && <FluxButton dense tint="accent" type="filled" slot="prefix" onClick={handleRemoveParticipant}> Remove me as participant</FluxButton>}
                            {badd === false && <FluxButton dense tint="accent" type="filled" slot="prefix" onClick={handleAddParticipant}>Add me as participant</FluxButton>}
                        </FluxListItem>
                        {requestedparticipants && requestedparticipants.length > 0 ? (
                            requestedparticipants.map((oneitem, idx) => {
                                const color = getParticipantColor(oneitem);
                                const isCurrentUser = oneitem === username;
                                return (
                                    <FluxListItem key={idx}>
                                        <Box sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            gap: 1,
                                            width: '100%'
                                        }}>
                                            <Avatar 
                                                sx={{ 
                                                    bgcolor: color,
                                                    fontWeight: 'bold',
                                                    color: '#fff',
                                                    width: 28,
                                                    height: 28,
                                                    fontSize: '0.75rem'
                                                }}
                                            >
                                                {getInitials(oneitem)}
                                            </Avatar>
                                            <Box sx={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                gap: 0.5,
                                                flex: 1
                                            }}>
                                                {fluxwrap(oneitem)}
                                                {isCurrentUser && (
                                                    <Chip 
                                                        label="You" 
                                                        size="small" 
                                                        sx={{ 
                                                            height: 18,
                                                            fontSize: '0.65rem',
                                                            bgcolor: color,
                                                            color: '#fff',
                                                            '& .MuiChip-label': { px: 0.5, py: 0 }
                                                        }} 
                                                    />
                                                )}
                                            </Box>
                                        </Box>
                                    </FluxListItem>
                                )
                            })
                        ) : (
                            <FluxListItem>
                                {fluxwrap("No participants have joined this ticket yet")}
                            </FluxListItem>
                        )}
                    </>}
                </FluxList>
                {loading && (
                    <div className={styles.Jira}>
                        <div className={styles.modal}>
                            <div className={styles.modalContent}>
                                <p>{loadingmessage}<FluxLoadingMessage></FluxLoadingMessage></p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Paper >
    );
}
export default Jirareporter;